<template>
  <div class="be-wrapper be-login">
    <div class="be-content">
      <div class="main-content container-fluid">
        <div class="splash-container forgot-password">
          <div class="panel panel-default panel-border-color panel-border-color-primary">
            <div class="panel-body">
              <temaplate v-if="!showConfirmationMessage">
                <form>
                  <span class="splash-title xs-pb-20"><h3>Сброс пароля</h3></span>
                  <div class="form-group" :class="{'has-error' : errors.has('email')}">
                    <label>Забыли пароль? Введите свой e-mail адрес ниже, и мы вышлем вам письмо для сброса пароля.</label>
                    <label class="control-label">Email</label>
                    <input v-validate="'required|email'" class="form-control"
                           data-vv-as="Email" :class="{'input': true, 'is-danger': errors.has('email') }" name="email"
                           type="text" placeholder="Email" v-model="email" autocomplete="on">
                    <span v-show="errors.has('email')" class="text-danger">{{ errors.first('email') }}</span>
                  </div>
                </form>
                <div class="form-group xs-pt-5">
                  <button class="btn btn-block btn-primary btn-xl" @click="submitData()">Сбросить мой пароль</button>
                </div>
              </temaplate>
              <template v-if="showConfirmationMessage">
                <p><h4>Письмо с инструкциями по восстановлению пароля отправлено</h4>
                Мы отправили вам инструкцию по установке нового пароля на указанный адрес электронной почты (если в нашей базе данных есть такой адрес). Вы должны получить ее в ближайшее время.</p>
                <p>Если вы не получили письмо, пожалуйста, убедитесь, что вы ввели адрес с которым Вы зарегистрировались, и проверьте папку со спамом.</p>
              </template>
              <div class="splash-footer">
                <span><router-link :to="{name:'login'}">Вернуться на страницу авторизации</router-link></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data () {
      return {
        email: null,
        errorMessages: null,
        showConfirmationMessage: false
      }
    },
    methods: {
      submitData () {
        this.errors.clear()
        this.errorMessages = null
        this.$validator.validateAll().then((result) => {
          if (result) {
            axios.post('/api/rest-auth/password/reset/', {'email': this.email}).then(
              (response) => {
                console.log(response)
                if (response.status === 200) {
                  this.showConfirmationMessage = true
                }
              },
              (error) => {
                if (error.response.status === 400) {
                  for (let [key, value] of Object.entries(error.response.data)) {
                    this.errors.add(key, value[0], 'server')
                  }
                  this.errors.add(error.response.data)
                } else if (error.response.status >= 500) {
                  this.errorMessages = ['Ошибка сервера регистрации. Попробуйте позже.']
                }
              }
            )
          } else {
            this.errorMessages = ['Проверьте введенные данные!']
          }
        })
      }
    }

  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/auth/ResetPassword.vue